<template>
<!-- Kopf der Ablauftabelle: die Stationsnamen ueber ihren Spalten, wie im
     Behelf. Nur bei mehr als einer Station. -->
<div v-if="stationen.length > 1" class="ablaufkopf">
    <span v-for="s in stationen" :key="s.rolle" :style="{ width: 100 / stationen.length + '%' }">
        {{ s.name }}<template v-if="s.rolle === ich"> (du)</template>
    </span>
</div>
</template>

<script>
import { stationenVon } from '@/logic/Einzug';

export default {
    props: {
        uebung: {type: Object, required: true},
        // Rolle, fuer die der Lernende spricht ("Reagieren"); sonst keine.
        ich: {type: String, default: null}
    },
    setup(props) {
        const stationen = stationenVon(props.uebung).map(rolle => ({
            rolle,
            name: props.uebung.zuege.find(z => z.spricht === rolle).station.rufname
        }))
        return { stationen }
    }
}
</script>

<style scoped>
/* Wie die Kopfzeile der Behelf-Tabelle: Rufnamen ueber ihren Spalten,
   darunter eine kraeftige Linie. */
.ablaufkopf {
    display: flex;
    margin: 0 0 0.85rem;
    border-bottom: 2px solid var(--zs-tinte);
}

.ablaufkopf span {
    padding: 0 0.5rem 0.4rem 0;
    font-size: 0.75rem;
    font-weight: 650;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--zs-tinte);
    box-sizing: border-box;
}
</style>
